import type { NextPage } from 'next'

import { Page } from 'src/components/layouts/Page'
import { AdminListApplications } from 'src/components/organisms/AdminListApplications'

import { withAdvisorRequired } from 'src/utils/auth'

const AdminListApplicationsPage: NextPage = () => {
  return (
    <Page title='Applications | Admin'>
      <AdminListApplications />
    </Page>
  )
}

export default withAdvisorRequired(AdminListApplicationsPage)
